'use strict'
import Vue from 'vue'
import { notification } from 'ant-design-vue'

let show = (type, message, description) => {
	return notification[type]({ message: message, description: description })
}

const notify = {
	install: function (Vue, options) {
		Vue.$notification = {
			info: (message, description) => show('info', message, description),
			warning: (message, description) => show('warning', message, description),
			error: (message, description) => show('error', message, description),
			success: (message, description) => show('success', message, description),
		}

		Vue.prototype.$notification = {
			info: (message, description) => show('info', message, description),
			warning: (message, description) => show('warning', message, description),
			error: (message, description) => show('error', message, description),
			success: (message, description) => show('success', message, description),
		}
	},
}

Vue.use(notify)

export default notify
